import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
import { FaPlus } from 'react-icons/fa';
import heroLatestModels from '../assets/hero-latest-models.jpg';
import heroLatestModelsMobile from '../assets/compressed/mobile/hero-latest-models.jpg';
import heroLatestModelsTablet from '../assets/compressed/tablet/hero-latest-models.jpg';
import './LatestModels.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const LatestModels = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('latest-models-discussions');

    return (
        <main className="latest-models-page">
            <Helmet>
                <title>Derniers Modèles Smartphones et Tablettes - Tech Passion</title>
                <meta name="description" content="Découvrez les derniers modèles de smartphones et tablettes : iPhone, Samsung Galaxy, Pixel, iPad et plus. Comparatifs, tests, caractéristiques et guides d'achat des appareils mobiles les plus récents." />
                <link rel="canonical" href="https://techpassion.fr/derniers-modeles" />
                <meta name="keywords" content="derniers smartphones, nouveaux modèles, iPhone, Samsung Galaxy, Google Pixel, iPad, tablettes, comparatif mobile, test smartphone, guide achat" />
                <meta property="og:title" content="Derniers Modèles Smartphones et Tablettes - Tech Passion" />
                <meta property="og:description" content="Explorez les derniers smartphones et tablettes : nouveautés, comparatifs et guides d'achat des meilleurs appareils mobiles." />
                <meta property="og:url" content="https://techpassion.fr/derniers-modeles" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>Derniers Modèles</h1>
                        <p>Découvrez et discutez des dernières innovations technologiques</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroLatestModels}
                    srcSet={`${heroLatestModelsMobile} 480w, ${heroLatestModelsTablet} 768w, ${heroLatestModels} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Présentation des derniers modèles de smartphones avec leurs caractéristiques innovantes et designs modernes"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="latest-models-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="latest-models-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default LatestModels;
